import { baseApi } from '@/api/core/baseApi';
import { unwrapListResponse, unwrapApiResponse } from '@/api/patterns/crud';
import type { PlatformHelpSubmission, UpdateSubmissionStatusArgs } from '../types';

export const platformHelpSubmissionsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPlatformHelpSubmissions: builder.query<PlatformHelpSubmission[], void>({
      query: () => '/platform/help-submissions',
      transformResponse: unwrapListResponse<PlatformHelpSubmission>,
      providesTags: [{ type: 'HelpSubmissions', id: 'LIST' }],
    }),

    updateHelpSubmissionStatus: builder.mutation<PlatformHelpSubmission, UpdateSubmissionStatusArgs>({
      query: ({ id, status }) => ({
        url: `/platform/help-submissions/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
      transformResponse: unwrapApiResponse<PlatformHelpSubmission>,
      invalidatesTags: [{ type: 'HelpSubmissions', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetPlatformHelpSubmissionsQuery,
  useUpdateHelpSubmissionStatusMutation,
} = platformHelpSubmissionsApi;
